// @flow
export const COMMITTED_CAPACITY = {
  ID_BACKEND_FIELD_NAME: 'id',
  METRIC_NAME_BACKEND_FIELD_NAME: 'metricName',
  METRIC_NAME_DISPLAY_NAME: 'Metric Name',
  QUANTITY_BACKEND_FIELD_NAME: 'quantity',
  QUANTITY_DISPLAY_NAME: 'Quantity',
  METRICS_LEVEL_CONFIGURATION_ARRAY: 'committed_capacity_inputs',
  METRICS_DIMENSIONS_LEVEL_CONFIGURATION_ARRAY:
    'committed_capacity_metrics_dimensions_level_configuration_array',
  ELIGIBILITY_DATA_BACKEND_FIELD_NAME: 'committed_capacity_eligibility',
  COMPLETE_METRICS_LIST: [
    {
      name: 'ecku',
      label: 'eCKU',
      dimensions: ['provider', 'cluster_type'],
      dimensionLabels: ['Cloud Provider', 'Cluster SKU'],
      minQuantityForAdmins: 0,
      minQuantityForNonAdmins: 10,
    },
    {
      name: 'cfu',
      label: 'CFU',
      dimensions: ['provider'],
      dimensionLabels: ['Cloud Provider'],
      minQuantityForAdmins: 0,
      minQuantityForNonAdmins: 25,
    },
  ],
};
